import React from 'react'
import Notification from 'rc-notification'
import classes from './notification.module.css'
import { v4 as uuid } from 'uuid'
import { ReactComponent as CheckIcon } from '../../assets/icons/check.svg'
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg'

let notificationInstance = null

function getNotificationInstance() {
    return new Promise(resolve => {
        if (notificationInstance) {
            resolve(notificationInstance)
            return
        }
        Notification.newInstance(
            {
                prefixCls: 'upturn-notif',
                style: {
                    top: 'auto',
                    right: 0,
                    bottom: 24,
                },
                closeIcon: <CloseIcon className={classes.close} />,
                transitionName: 'notif-trans',
                maxCount: 5,
            },
            n => {
                if (notificationInstance) {
                    resolve(notificationInstance)
                    return
                }
                notificationInstance = n
                resolve(notificationInstance)
            }
        )
    })
}

function renderNotification({
    duration = 2,
    closable = true,
    iconNode,
    title,
    description,
    onClose,
    style,
    className,
    key,
}) {
    return {
        content: (
            <div className={classes.notificationWrapper}>
                <div className={classes.notificationIcon}>{iconNode}</div>
                <div className={classes.notificationMessage}>
                    {!!title && (
                        <h5 className={classes.notificationTitle}>{title}</h5>
                    )}
                    {!!description && (
                        <p className={classes.notificationDescription}>
                            {description}
                        </p>
                    )}
                </div>
            </div>
        ),
        key,
        onClose,
        duration: closable ? duration : 0,
        closable,
        style: style || {},
        className,
    }
}

const api = {
    destroy() {
        if (notificationInstance) {
            notificationInstance.destroy()
            notificationInstance = null
        }
    },
    async notify({
        title,
        description,
        icon,
        closable = true,
        duration = 2.5,
        onClose,
    }) {
        const instance = await getNotificationInstance()
        const key = uuid()
        const dismiss = () => {
            instance.removeNotice(key)
            if (typeof onClose === 'function') onClose(key)
        }
        instance.notice(
            renderNotification({
                key,
                iconNode: icon,
                duration,
                closable,
                title,
                description,
                onClose:
                    typeof onClose === 'function' ? () => onClose(key) : null,
            })
        )
        return [dismiss, key]
    },
    async loading({ title, description, ...props }) {
        return api.notify({
            ...props,
            title,
            description,
            icon: <div className={classes.loading} />,
            closable: false,
            duration: 0,
        })
    },
    async success({ title, description, onClose, ...props }) {
        return api.notify({
            ...props,
            title,
            description,
            onClose,
            icon: <CheckIcon className={classes.success} />,
        })
    },
    async failure({ title, description, onClose, ...props }) {
        return api.notify({
            ...props,
            title,
            description,
            onClose,
            icon: <CloseIcon className={classes.failure} />,
        })
    },
    async info({ title, description, onClose, ...props }) {
        return api.notify({
            ...props,
            title,
            description,
            onClose,
            icon: null,
        })
    },
}

// this line helps intellisense import this file as notification
// and not api
const notification = api

export default notification
